import React from 'react';

import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class Produtos extends React.Component {

    componentDidMount() {
        $('.dataTable').DataTable({
            lengthChange: false,
            info: false,
            pageLength: 8,
            pagingType: "simple_numbers",
            buttons: [],
            order: [[ 1, "desc" ]],
            columnDefs: [
                {orderable: false, targets: -1}
            ],
        });
    }

    render() {
        const produtos = this.props.sorteio.products;

        const count = (itemId) => {
            return this.props.sorteio.paidOrders
                .filter((order) => order.items.some((item) => item.id_produto == itemId))
                .reduce((acc, order) => acc + order.items.find((item) => item.id_produto == itemId).quantidade, 0);
        };
        const isSelected = (itemId) => {
            const selectedItemsIds = this.props.sorteio.selectedItemsIds;
            return selectedItemsIds.some((id) => id == itemId);
        };
        const onSelectItem = (itemId) => {
            const newValue = this.props.sorteio.selectedItemsIds.slice();
            newValue.push(itemId);
            this.props.events.onUpdateLotteryConfig('selectedItemsIds', newValue);
        };

        const itens = produtos.map(p => (
            <tr key={p.id}>
                <td>{p.name}</td>
                <td>{count(p.id)}</td>
                <td className="text-center">
                    <button type="button" className="btn btn-sm btn-default"
                        onClick={() => onSelectItem(p.id)}
                        disabled={count(p.id) == 0 || isSelected(p.id)}>
                    <i className="glyphicon glyphicon-plus"></i>
                    </button>
                </td>
            </tr>
        ));

        return (
            <div className="panel panel-color panel-primary">
                <div className="panel-heading">
                    <h3 className="panel-title">Produtos</h3>
                </div>
                <div className="panel-body">
                    <div className="table-responsive">
                        <table className="table  dataTable">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th style={{"width": "10%"}}>Vendidos</th>
                                    <th className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

class Filtro extends React.Component {

    render() {
        const lottery = this.props.sorteio;
        const produtos = lottery.products;
        const selectedItems = lottery.selectedItemsIds.map(id => produtos.find(p => p.id == id));
        const numberOfParticipants = _.uniqBy(lottery.filteredOrders, order => order.cpf).length;

        const onConfigureLottery = () => {
            const promise = this.props.events.onListParticipants(this.props.participants.selectedEvent.id, this.props.token);
            promise.then(() => this.props.events.onConfigureLottery(this.props.participants.selectedEvent.id, this.props.sorteio.selectedItemsIds, this.props.token));
        };

        const itens = selectedItems.map(p => (
            <tr key={p.id}>
                <td>{p.name}</td>
            </tr>
        ));

        return (
            <div className="panel panel-color panel-primary">
                <div className="panel-heading">
                    <h3 className="panel-title">Produtos selecionados - {numberOfParticipants + ' participante(s)'}</h3>
                </div>
                <div className="panel-body">
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="panel-footer">
                    <label>Prêmios:</label>
                    <button type="button" className="btn btn-sm btn-default"
                        onClick={() => this.props.events.onUpdateLotteryConfig('prizesCount', lottery.prizesCount + 1)}>
                        <i className="glyphicon glyphicon-plus"></i>
                    </button>
                    <a className="btn btn-sm btn-default disabled">{lottery.prizesCount}</a>
                    <button type="button" className="btn btn-sm btn-default" disabled={lottery.prizesCount == 1}
                        onClick={() => this.props.events.onUpdateLotteryConfig('prizesCount', lottery.prizesCount - 1)}>
                        <i className="glyphicon glyphicon-minus"></i>
                    </button>
                    <button className="btn btn-primary pull-right" onClick={onConfigureLottery}>Configurar</button>
                </div>
            </div>
        );
    }
}

class Sorteio extends React.Component {

    render() {
        const app = this.props.app;
        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.SORTEIO)
            return null;

        return (
            <div className="wraper container-fluid" >
                <div className="row">
                    <div className="col-lg-7">
                      <Produtos {...this.props} />
                    </div>
                    <div className="col-lg-5">
                      <Filtro {...this.props} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Sorteio;



// WEBPACK FOOTER //
// src/views/pages/Sorteio.jsx